import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";

// ✅ Custom red marker icon to fix Leaflet marker visibility issue in React
const RedIcon = new L.Icon({
  iconUrl: "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-red.png",
  shadowUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png",
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
});

export default function ComplaintDetails() {
  const { id } = useParams();
  const [complaint, setComplaint] = useState(null);
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "http://localhost:5000";

  useEffect(() => {
    const fetchComplaint = async () => {
      try {
        const res = await axios.get(`${BACKEND_URL}/api/admin/complaints/${id}`);
        setComplaint(res.data);
      } catch (err) {
        console.error("Error fetching complaint:", err);
      }
    };
    fetchComplaint();
  }, [id]);

  if (!complaint) return <p>Loading complaint details...</p>;

  return (
    <div style={{ padding: "2rem" }}>
      <h2>{complaint.title}</h2>
      <p><strong>Description:</strong> {complaint.description}</p>
      <p><strong>Status:</strong> {complaint.status}</p>
      <p><strong>User:</strong> {complaint.user?.name} ({complaint.user?.email})</p>
      <p><strong>Location:</strong> {complaint.address ? `${complaint.address.street}, ${complaint.address.town}, ${complaint.address.district || ""}` : "N/A"}</p>

      {complaint.location?.coordinates && complaint.location.coordinates.length === 2 && (
        <div style={{ marginTop: "1rem" }}>
          <MapContainer
            center={[complaint.location.coordinates[1], complaint.location.coordinates[0]]}
            zoom={14}
            style={{ height: "400px", width: "100%" }}
          >
            <TileLayer
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
            />
            <Marker position={[complaint.location.coordinates[1], complaint.location.coordinates[0]]} icon={RedIcon}>
              <Popup>
                {complaint.address ? `${complaint.address.street}, ${complaint.address.town}` : "Complaint Location"}
              </Popup>
            </Marker>
          </MapContainer>
        </div>
      )}
    </div>
  );
}